import { state } from '@/shared/components/player/store';
import { RouteName } from '@/shared/enums';
import { replaceEmbeddedRoute } from '@/shared/utils';

export default {
  computed: {
    nextEpisode() {
      return state.nextEpisode || {};
    },
  },
  methods: {
    playNextEpisode() {
      const { label, slug, type } = this.$route.params;
      const { id: articleId, slug: articleSlug, type: articleType, season } = this.nextEpisode;

      this.$stats.playNext(state.product);

      if (state.isEmbedded) {
        return replaceEmbeddedRoute({ slug, id: season.serial.id, type, articleId, articleType, articleSlug, component: this });
      }

      this.$router.replace({
        name: RouteName.DETAIL_WITH_ARTICLE,
        params: {
          label,
          slug,
          type,
          id: season.serial.id,
          articleSlug,
          articleType: articleType.toLowerCase(),
          articleId,
        },
      });
    },
  },
};
